import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
    Alert,
    Box,
    Button,
    Chip,
    Container,
    Divider,
    Fade,
    Grid,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { addToCart } from '../features/cartSlices';
import { getProduct, getShop } from '../features/slices';

const defaultVariants = {
    clothing: {
        colors: [
            { name: 'Black', code: '#000' },
            { name: 'White', code: '#fff' },
            { name: 'Navy', code: '#13294b' },
            { name: 'Red', code: '#c8102e' },
            { name: 'Gray', code: '#a7a1a1' },
            { name: 'Pink', code: '#f7a6c7' },
            { name: 'Green', code: '#2cb67d' },
            { name: 'Sky', code: '#bcd3e6' }
        ],
        sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'],
        sizechart: `<p><img src="http://dtheran.com/wp-content/uploads/2024/12/tshirt.png"></p>
<table class="sizechart">
    <thead>
        <tr>
            <th>Size</th>
            <th>Length</th>
            <th>Width</th>
            <th>Sleeve Center Back</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>S</td>
            <td>28</td>
            <td>18</td>
            <td>15.6</td>
        </tr>
        <tr>
            <td>M</td>
            <td>29</td>
            <td>20</td>
            <td>17.9</td>
        </tr>
        <tr>
            <td>L</td>
            <td>30</td>
            <td>22</td>
            <td>18</td>
        </tr>
        <tr>
            <td>XL</td>
            <td>31</td>
            <td>24</td>
            <td>20.6</td>
        </tr>
        <tr>
            <td>2XL</td>
            <td>32</td>
            <td>26</td>
            <td>22.1</td>
        </tr>
        <tr>
            <td>3XL</td>
            <td>33</td>
            <td>28</td>
            <td>23.4</td>
        </tr>
        <tr>
            <td>4XL</td>
            <td>34</td>
            <td>30</td>
            <td>24.9</td>
        </tr>
        <tr>
            <td>5XL</td>
            <td>35</td>
            <td>32</td>
            <td>26.4</td>
        </tr>
    </tbody>
</table>
<p><img src="http://dtheran.com/wp-content/uploads/2024/12/sweaater.png"></p>
<table class="sizechart">
    <thead>
        <tr>
            <th>Size</th>
            <th>Width</th>
            <th>Length</th>
            <th>Sleeve Center Back</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>S</td>
            <td>20</td>
            <td>27</td>
            <td>33.5</td>
        </tr>
        <tr>
            <td>M</td>
            <td>22</td>
            <td>28</td>
            <td>34.5</td>
        </tr>
        <tr>
            <td>L</td>
            <td>24</td>
            <td>29</td>
            <td>35.5</td>
        </tr>
        <tr>
            <td>XL</td>
            <td>26</td>
            <td>30</td>
            <td>36.5</td>
        </tr>
        <tr>
            <td>2XL</td>
            <td>28</td>
            <td>31</td>
            <td>37.5</td>
        </tr>
        <tr>
            <td>3XL</td>
            <td>30</td>
            <td>32</td>
            <td>38.5</td>
        </tr>
        <tr>
            <td>4XL</td>
            <td>32</td>
            <td>33</td>
            <td>39.5</td>
        </tr>
        <tr>
            <td>5XL</td>
            <td>34</td>
            <td>34</td>
            <td>40.5</td>
        </tr>
    </tbody>
</table>
<p><img src="http://dtheran.com/wp-content/uploads/2024/12/hoodie-1.png"></p>
<table class="sizechart">
    <thead>
        <tr>
            <th>Size</th>
            <th>Width</th>
            <th>Length</th>
            <th>Sleeve Center Back</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>S</td>
            <td>20</td>
            <td>27</td>
            <td>33.5</td>
        </tr>
        <tr>
            <td>M</td>
            <td>22</td>
            <td>28</td>
            <td>34.5</td>
        </tr>
        <tr>
            <td>L</td>
            <td>24</td>
            <td>29</td>
            <td>35.5</td>
        </tr>
        <tr>
            <td>XL</td>
            <td>26</td>
            <td>30</td>
            <td>36.5</td>
        </tr>
        <tr>
            <td>2XL</td>
            <td>28</td>
            <td>31</td>
            <td>37.5</td>
        </tr>
        <tr>
            <td>3XL</td>
            <td>30</td>
            <td>32</td>
            <td>38.5</td>
        </tr>
    </tbody>
</table>
<p><img src="http://dtheran.com/wp-content/uploads/2024/12/zip.png"></p>
<table class="sizechart">
    <thead>
        <tr>
            <th>Size</th>
            <th>Width</th>
            <th>Length</th>
            <th>Sleeve Center Back</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>S</td>
            <td>20</td>
            <td>27</td>
            <td>33.5</td>
        </tr>
        <tr>
            <td>M</td>
            <td>22</td>
            <td>28</td>
            <td>34.5</td>
        </tr>
        <tr>
            <td>L</td>
            <td>24</td>
            <td>29</td>
            <td>35.5</td>
        </tr>
        <tr>
            <td>XL</td>
            <td>26</td>
            <td>30</td>
            <td>36.5</td>
        </tr>
        <tr>
            <td>2XL</td>
            <td>28</td>
            <td>31</td>
            <td>37.5</td>
        </tr>
        <tr>
            <td>3XL</td>
            <td>30</td>
            <td>32</td>
            <td>38.5</td>
        </tr>
    </tbody>
</table>
<p><img src="http://dtheran.com/wp-content/uploads/2024/12/tank-top.png"></p>
<table class="sizechart">
    <tbody>
        <tr>
            <th>Size</th>
            <th>Length (inches)</th>
            <th>Width (inches)</th>
        </tr>
        <tr>
            <td>S</td>
            <td>28.0 in</td>
            <td>36.0 in</td>
        </tr>
        <tr>
            <td>M</td>
            <td>29.0 in</td>
            <td>40.0 in</td>
        </tr>
        <tr>
            <td>L</td>
            <td>30.0 in</td>
            <td>44.0 in</td>
        </tr>
        <tr>
            <td>XL</td>
            <td>31.0 in</td>
            <td>48.0 in</td>
        </tr>
        <tr>
            <td>2XL</td>
            <td>32.0 in</td>
            <td>52.0 in</td>
        </tr>
        <tr>
            <td>3XL</td>
            <td>33.0 in</td>
            <td>56.0 in</td>
        </tr>
    </tbody>
</table>`
    },
    NFL: {
        type: [
            "Men", "Women", "Youth"
        ],
        sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'],
        sizechart: `<div class="wpb-psc-size-content entry-content wpb-psc-size-content-before"><p><strong style="color: red;">Suggestion: Please compare your chest measurement with the measurements in the table below.</strong></p>
<p>MEN (0.5 inch to 1.5 inch tolerance range)</p>
<p>&nbsp;</p>
<table>
<tbody>
<tr>
<th>Size</th>
<th>Chest (in)</th>
<th>Waist (in)</th>
<th>Length (in)</th>
</tr>
<tr>
<td>S</td>
<td>41 - 43</td>
<td>40 - 42</td>
<td>28 - 29</td>
</tr>
<tr>
<td>M</td>
<td>44 - 45</td>
<td>43 - 44</td>
<td>29.5 - 30</td>
</tr>
<tr>
<td>L</td>
<td>46 - 47</td>
<td>45 - 46</td>
<td>30.5 - 31</td>
</tr>
<tr>
<td>XL</td>
<td>48 - 49</td>
<td>47 - 48</td>
<td>31.5 - 32</td>
</tr>
<tr>
<td>2XL</td>
<td>50 - 53</td>
<td>49 - 52</td>
<td>32.5 - 33</td>
</tr>
<tr>
<td>3XL</td>
<td>54 - 56</td>
<td>53 - 55</td>
<td>33.5 - 34</td>
</tr>
<tr>
<td>4XL</td>
<td>57 - 59</td>
<td>56 - 58</td>
<td>34.5 - 35</td>
</tr>
<tr>
<td>5XL</td>
<td>60 - 63</td>
<td>59 - 62</td>
<td>35.5 - 36</td>
</tr>
</tbody>
</table>
<p>WOMEN (0.5 inch to 1.5 inch tolerance range)</p>
<table>
<tbody>
<tr>
<th>Size</th>
<th>Chest (in)</th>
<th>Waist (in)</th>
<th>Length (in)</th>
</tr>
<tr>
<td>S</td>
<td>32.5 - 35.5</td>
<td>26 - 29</td>
<td>21.5 - 22.5</td>
</tr>
<tr>
<td>M</td>
<td>35.5 - 38.5</td>
<td>29 - 31.5</td>
<td>22.5 - 23.5</td>
</tr>
<tr>
<td>L</td>
<td>38.5 - 41.5</td>
<td>31.5 - 34.5</td>
<td>23.5 - 25.5</td>
</tr>
<tr>
<td>XL</td>
<td>41.5 - 44.5</td>
<td>34.5 - 38.5</td>
<td>25.5 - 27.5</td>
</tr>
<tr>
<td>XXL</td>
<td>44.5 - 48.5</td>
<td>38.5 - 42.5</td>
<td>27.5 - 29.5</td>
</tr>
</tbody>
</table>
<p>YOUTH (0.5 inch to 1.5 inch tolerance range)</p>
<table>
<tbody>
<tr>
<th>Size</th>
<th>U.S. Size</th>
<th>Chest (in)</th>
<th>Length (in)</th>
</tr>
<tr>
<td>YTH S</td>
<td>8</td>
<td>32 - 34</td>
<td>22 - 23.5</td>
</tr>
<tr>
<td>YTH M</td>
<td>10/12</td>
<td>35 - 37</td>
<td>24 - 25.5</td>
</tr>
<tr>
<td>YTH L</td>
<td>14/16</td>
<td>38 - 40</td>
<td>26 - 27.5</td>
</tr>
<tr>
<td>YTH XL</td>
<td>18/20</td>
<td>41 - 43</td>
<td>28 - 29.5</td>
</tr>
</tbody>
</table>
</div>`
    },
    lamp: {
    }
};

export default function ProductDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const productRaw = useSelector((state) => state.shop.product);
    const { template, products } = useSelector((state) => state.shop);
    const [quantity, setQuantity] = useState(1);
    const [openSizeChart, setOpenSizeChart] = useState(false);
    const [product, setProduct] = useState(null);
    const [selectedColor, setSelectedColor] = useState({ name: 'Black', code: '#000' });
    const [selectedSize, setSelectedSize] = useState('S');
    const [mainImage, setMainImage] = useState('');
    const [tabIndex, setTabIndex] = useState(0);
    const [showUpdateMessage, setShowUpdateMessage] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleAddToCart = () => {
        dispatch(addToCart({
            product,
            quantity,
            color: selectedColor,
            size: selectedSize
        }));
        setShowUpdateMessage(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Hide the success message after 3 seconds
        setTimeout(() => {
            setShowUpdateMessage(false);
        }, 3000);
    };

    const handleBuyNow = () => {
        dispatch(addToCart({
            product,
            quantity,
            color: selectedColor,
            size: selectedSize
        }));
        navigate('/checkout');
    };


    useEffect(() => {
        dispatch(getProduct({ productId: id }));
    }, [id]);
    useEffect(() => {
        dispatch(getShop({ template, page: 1, limit: 5 }))
    }, []);
    useEffect(() => {
        if (productRaw?.id) {
            const v = defaultVariants[productRaw.template || 'clothing'];
            setProduct({ ...productRaw, ...v });
            setSelectedColor(v.colors ? v.colors[0] : null);
            // setSelectedSize("S");
            setMainImage(productRaw.images?.[0] || productRaw.image?.[0]);
        }
    }, [productRaw]);

    if (!product) return <Typography sx={{ p: 4 }}>Loading...</Typography>;

    return (
        <Container maxWidth="xl" sx={{ py: 5 }}>
            <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: 'silver', fontSize: '0.9rem' }}>
                    Home / Collections /
                </Typography>
                <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 600 }}>
                    {product.name}
                </Typography>
            </Box>

            <Fade in={showUpdateMessage}>
                <Alert severity="success" sx={{ mt: 2, mb: 2 }}>Add "{product.name}" to cart success.</Alert>
            </Fade>

            <Grid container spacing={4}>
                {/* LEFT + RIGHT COMBINED */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: 4
                        }}
                    >
                        {/* LEFT IMAGE */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: { xs: 'center', md: 'flex-start' },
                            }}
                        >
                            {/* Thumbnails */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'row', md: 'column' },
                                    gap: 1,
                                    flexShrink: 0,
                                    maxWidth: { xs: '100%', md: 70 },
                                    overflowX: 'auto'
                                }}
                            >
                                {product.image && product.image.length > 0 ? (
                                    product.image.map((img, index) => (
                                        <Box
                                            key={index}
                                            component="img"
                                            src={img}
                                            onClick={() => setMainImage(img)}
                                            alt={`thumb-${index}`}
                                            sx={{
                                                width: 60,
                                                height: 60,
                                                objectFit: 'cover',
                                                border: mainImage === img ? '2px solid #000' : '1px solid #ccc',
                                                borderRadius: 1,
                                                cursor: 'pointer',
                                                flexShrink: 0
                                            }}
                                        />
                                    ))
                                ) : (
                                    <Typography variant="body2">No Thumbnails</Typography>
                                )}
                            </Box>

                            {/* Main Image */}
                            <Box sx={{ flex: 1 }}>
                                <Box
                                    component="img"
                                    src={mainImage}
                                    alt={product.name}
                                    sx={{
                                        width: '100%',
                                        aspectRatio: '6 / 6',
                                        borderRadius: 2,
                                        maxHeight: 700,
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* RIGHT INFO */}
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                            {/* Title & Reviews */}
                            <Box>
                                <Typography variant="h5" fontWeight={700}>{product.name}</Typography>

                                <Typography variant="body2" color="text.secondary">
                                    {product.reviews || 128} Reviews
                                </Typography>
                            </Box>
                            <Divider></Divider>

                            {/* Color */}
                            {product.colors && product.colors.length > 0 && <Box>
                                <Typography fontWeight={600}>
                                    Color: {selectedColor && selectedColor.name}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
                                    {product.colors.map((color) => (
                                        <Box
                                            key={color.code}
                                            onClick={() => setSelectedColor(color)}
                                            sx={{
                                                width: 42,
                                                height: 42,
                                                borderRadius: '50%',
                                                border: selectedColor?.code === color.code ? '3px solid black' : '1px solid #ccc',
                                                backgroundColor: color.code,
                                                cursor: 'pointer'
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>}

                            {/* Size */}
                            {product.sizes && product.sizes.length > 0 && <Box>
                                <Typography fontWeight={600}>Size: {selectedSize}</Typography>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
                                    {product.sizes.map((size) => (
                                        <Chip
                                            key={size}
                                            label={size}
                                            variant={selectedSize === size ? 'filled' : 'outlined'}
                                            color={selectedSize === size ? 'primary' : 'default'}
                                            onClick={() => setSelectedSize(size)}
                                            sx={{ px: 2, height: 40, fontWeight: 600 }}
                                        />
                                    ))}
                                </Box>
                                {product.sizechart && (
                                    <>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                            <IconButton
                                                onClick={() => setOpenSizeChart(true)}
                                                sx={{ p: 0.5 }}
                                                title="View Size Chart"
                                            >
                                                <InfoOutlinedIcon sx={{ color: '#1976d2' }} />
                                            </IconButton>
                                            <Typography
                                                variant="body2"
                                                sx={{ ml: 1, color: '#1976d2', fontWeight: 600, cursor: 'pointer' }}
                                                onClick={() => setOpenSizeChart(true)}
                                            >
                                                Size Chart
                                            </Typography>
                                        </Box>

                                        <Dialog open={openSizeChart} onClose={() => setOpenSizeChart(false)} maxWidth="sm" fullWidth>
                                            <DialogTitle>Size Chart</DialogTitle>
                                            <DialogContent dividers>
                                                <Box
                                                    sx={{
                                                        width: '100%', overflowX: 'auto', '& .sizechart': {
                                                            width: '100%',
                                                            borderCollapse: 'collapse',
                                                            marginBottom: '32px',
                                                            fontSize: '0.95rem',
                                                            textAlign: 'center',
                                                        },
                                                        '& .sizechart th, & .sizechart td': {
                                                            border: '1px solid #ddd',
                                                            padding: '10px 12px',
                                                        },
                                                        '& .sizechart thead': {
                                                            backgroundColor: '#f5f5f5',
                                                            fontWeight: 'bold',
                                                        },
                                                        '& .sizechart tr:nth-of-type(even)': {
                                                            backgroundColor: '#fafafa',
                                                        },
                                                        '& img': {
                                                            maxWidth: '100%',
                                                            height: 'auto',
                                                            display: 'block',
                                                            margin: '16px auto',
                                                        },
                                                    }}
                                                    dangerouslySetInnerHTML={{ __html: product.sizechart }}
                                                />
                                            </DialogContent>
                                        </Dialog>
                                    </>
                                )}

                            </Box>}
                            <Divider></Divider>

                            {/* Price */}
                            <Typography fontWeight={700} fontSize="1.5rem">
                                Total:{' '}
                                <span style={{ color: 'crimson' }}>
                                    ${(product.price * quantity).toFixed(2)}
                                </span>
                            </Typography>


                            {/* Quantity + Add to Cart */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    alignItems: 'center',
                                    width: '100%',
                                    mt: 1
                                }}
                            >
                                {/* Quantity Selector */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: 45,
                                        border: '1px solid #ccc',
                                        borderRadius: 1,
                                        overflow: 'hidden',
                                        flexShrink: 0
                                    }}
                                >
                                    <Button
                                        onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                                        sx={{
                                            minWidth: 45,
                                            height: 45,
                                            fontSize: '1.25rem',
                                            borderRadius: 0,
                                            borderRight: '1px solid #ccc'
                                        }}
                                    >
                                        –
                                    </Button>
                                    <Box
                                        component="input"
                                        type="number"
                                        value={quantity}
                                        onChange={(e) => {
                                            const val = Math.max(1, parseInt(e.target.value) || 1);
                                            setQuantity(val);
                                        }}
                                        sx={{
                                            width: 60,
                                            height: 45,
                                            textAlign: 'center',
                                            border: 'none',
                                            fontSize: '1rem',
                                            outline: 'none',
                                            '&::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            '&::-webkit-outer-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            // Firefox
                                            MozAppearance: 'textfield',
                                        }}
                                    />
                                    <Button
                                        onClick={() => setQuantity(prev => prev + 1)}
                                        sx={{
                                            minWidth: 45,
                                            height: 45,
                                            fontSize: '1.25rem',
                                            borderRadius: 0,
                                            borderLeft: '1px solid #ccc'
                                        }}
                                    >
                                        +
                                    </Button>
                                </Box>

                                {/* Add to Cart */}
                                <Button
                                    onClick={handleAddToCart}
                                    variant="contained"
                                    sx={{
                                        height: 45,
                                        px: 4,
                                        flexGrow: 1,
                                        backgroundColor: '#092C3E',
                                        fontWeight: 600,
                                        fontSize: '0.95rem'
                                    }}
                                >
                                    ADD TO CART
                                </Button>
                            </Box>


                            {/* Buy Now */}
                            <Box sx={{ width: '100%' }}>
                                <Button
                                    onClick={handleBuyNow}
                                    variant="contained"
                                    fullWidth
                                    sx={{ backgroundColor: '#B31919', height: 45, mt: 1 }}
                                >
                                    BUY NOW
                                </Button>
                            </Box>

                            {/* Payment Icons */}
                            <Box sx={{ width: '100%' }}>
                                <Typography fontWeight={700} fontSize="0.95rem" sx={{}}>
                                    GUARANTEED <span style={{ color: 'red' }}>SAFE</span> CHECKOUT
                                </Typography>
                                <Box component="img" src="/src/safe-checkout.webp" alt="Secure" sx={{
                                    mt: 1,
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    borderRadius: 1
                                }} />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ mt: 4 }}>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                        border: '1px solid #eee',
                        borderRadius: '12px',
                        px: 1,
                        '& .MuiTab-root': {
                            fontWeight: 600,
                            textTransform: 'none',
                        },
                    }}
                >
                    <Tab label="Description" />
                    <Tab label="Shipping Policy" />
                    <Tab label="Return Policy" />
                    <Tab label="Payment Methods" />
                </Tabs>

                <Box sx={{ mt: 2 }}>
                    {tabIndex === 0 && (
                        <Typography variant="body2">
                            {/* Thay bằng dữ liệu mô tả sản phẩm */}
                            {<Box
                                sx={{
                                    width: '100%', overflowX: 'auto'
                                }}
                                dangerouslySetInnerHTML={{ __html: product.description }}
                            /> || 'No description provided.'}

                        </Typography>
                    )}
                    {tabIndex === 1 && (
                        <Box>
                            <Typography variant="body2" fontWeight={700}>Production time:</Typography>
                            <ul>
                                <li><strong>Standard Shipping:</strong> Orders typically ship within <strong>1–2 days</strong> or <strong>3–4 days</strong>, depending on your chosen options.</li>
                                <li><strong>Priority Shipping:</strong> All products ship within <strong>2–4 days</strong>.</li>
                            </ul>
                            <Typography variant="body2" fontWeight={700} mt={2}>Shipping time:</Typography>
                            <ul>
                                <li><strong>Standard Shipping:</strong> Delivery takes <strong>3–4 days</strong> or <strong>4–7 days</strong>.</li>
                                <li><strong>Priority Shipping:</strong> Delivery typically takes <strong>4–5 days</strong>.</li>
                            </ul>
                        </Box>
                    )}
                    {tabIndex === 2 && (
                        <Box>
                            <p>While we strive to ensure every order is perfect, occasional issues may occur. If your order has any problems, we offer refunds or replacements where applicable. To request a refund or replacement, please submit a claim along with photo or video evidence of the received item.</p>

                            <p><strong>Cases eligible for Refund or Replacement:</strong></p>
                            <ul>
                                <li>Defective or damaged item upon delivery (e.g., broken, scratched, dented, or malfunctioning).</li>
                                <li>Product not functioning as described or expected (e.g., electronic items not powering on, accessories missing, misprints, etc.).</li>
                                <li>Incorrect product received (wrong item, size, color, model, or variant).</li>
                                <li>Product significantly different from description or images on the website.</li>
                                <li>Shipping damage or packaging defects that compromise the product.</li>
                                <li>Lost packages (when the shipping address provided was accurate).</li>
                            </ul>

                            <p><strong>Return Process:</strong></p>
                            <ul>
                                <li>Return or refund requests must be submitted within <strong>14 business days</strong> from the delivery date.</li>
                                <li>Requests made after <strong>14 business days</strong> will not be accepted. Items returned without prior approval will be forfeited.</li>
                                <li>Return shipping costs are the customer’s responsibility unless otherwise confirmed by our support team.</li>
                                <li>Return instructions will be provided via email once the request is approved.</li>
                                <li>Refunds are typically processed within <strong>5–10 business days</strong> after the returned item is received and inspected.</li>
                            </ul>

                            <p><strong>Non-Refundable / Non-Returnable Situations:</strong></p>
                            <ul>
                                <li>Change of mind after product is shipped.</li>
                                <li>Incorrect choices made by the customer (e.g., wrong size, color, model, or custom input).</li>
                                <li>Products marked as non-returnable, such as final sale or clearance items.</li>
                                <li>Delays caused by shipping carriers outside our control (unless the package is lost).</li>
                            </ul>

                            <p>Our goal is to ensure your satisfaction, so if you're unsure whether your issue qualifies, feel free to contact our customer service team for further assistance.</p>
                        </Box>
                    )}
                    {tabIndex === 3 && (
                        <Box sx={{
                            '& table': {
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '32px',
                                fontSize: '0.95rem',
                                textAlign: 'center',
                            },
                            '& table th, & table td': {
                                border: '1px solid #ddd',
                                padding: '10px 12px',
                            },
                            '& table thead': {
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                            },
                            '& table tr:nth-of-type(even)': {
                                backgroundColor: '#fafafa',
                            }
                        }}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td><strong>Payment Option</strong></td>
                                        <td><strong>Information</strong></td>
                                    </tr>
                                    <tr>
                                        <td>Visa</td>
                                        <td>We accept Visa card payments, offering a secure and globally trusted method for convenient checkout.</td>
                                    </tr>
                                    <tr>
                                        <td>PayPal</td>
                                        <td>Pay securely using your PayPal account or linked bank card. Ideal for buyers who prefer a fast and protected transaction method.</td>
                                    </tr>
                                    <tr>
                                        <td>Stripe</td>
                                        <td>Our store is integrated with Stripe, allowing you to pay effortlessly using your credit or debit card through a secure gateway.</td>
                                    </tr>
                                    <tr>
                                        <td>Mastercard</td>
                                        <td>Mastercard payments are also accepted, giving you flexibility and confidence when placing your order.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Box>
                    )}
                </Box>
            </Box>


            <Typography variant="h4" sx={{ mt: 5, mb: 2 }}>New Arrivals</Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    p: 0,
                    m: 0,
                }}
            >
                {products.map((product) => (
                    <Box
                        key={product.id}
                        sx={{
                            width: {
                                xs: '100%',  // 1 cột trên điện thoại
                                sm: '50%',   // 2 cột trên màn hình nhỏ
                                md: '33.33%',// 3 cột trên tablet
                                lg: '25%',   // 4 cột trên desktop vừa
                                xl: '20%',   // 5 cột trên desktop lớn
                            },
                            p: 1,
                            boxSizing: 'border-box',
                        }}
                    >
                        <ProductCard product={product} />
                    </Box>
                ))}
            </Box>
        </Container >

    );
}
